// turnstile.js
'use strict';
import loadScriptTag from '../resource/loadScriptTag.js';
import { turnstile } from '../resource/debug.js';
import env from '../resource/env.js';

const log = turnstile.extend('log');

const SCRIPT_ID = 'turnstile-api-script-id';
export const TURNSTILE_CONTAINER_ID = 'turnstile-invisible';

const isProd = env.NODE_ENV === 'production';

let waitingPromiseResolve;
const generateWaitingPromise = () =>
  new Promise(resolve => {
    waitingPromiseResolve = resolve;
  });
let isGeneratingTokenPromise;
let widgetId;
let storedParams;

export const initTurnstile = async params => {
  const { sitekey, isReset, ...otherParams } = params;
  storedParams = { sitekey, ...otherParams };
  log('initTurnstile', params);

  try {
    if (!document.getElementById(SCRIPT_ID)) {
      log('load turnstile script');
      await loadScriptTag({
        id: SCRIPT_ID,
        async: false,
        src: 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit',
      });

      if (window.turnstile)
        await new Promise(resolve => window.turnstile.ready(resolve));
      else throw new Error('turnstile script error');
      log('load turnstile script done');
    }

    if ((window.turnstile && !widgetId) || isReset) {
      log('render turnstile');
      isGeneratingTokenPromise = generateWaitingPromise();
      widgetId = window.turnstile.render(`#${TURNSTILE_CONTAINER_ID}`, {
        sitekey,
        size: 'invisible',
        callback: token => {
          log('get token success', token);
          waitingPromiseResolve();
        },
        'expired-callback': () => {
          log('token expired');
          isGeneratingTokenPromise = generateWaitingPromise();
        },
        // when turnstile refresh, console always jumps to source tab,
        // only enable refresh mechanism in prod mode
        'refresh-expired': isProd ? 'auto' : 'never',
        'error-callback': error => {
          log('error', error);
          isGeneratingTokenPromise = null;
          window.turnstile.remove();
          throw new Error(error);
        },
        'unsupported-callback': reason => {
          log('unsupported', reason);
          isGeneratingTokenPromise = null;
          window.turnstile.remove();
          throw new Error(reason);
        },
        ...otherParams,
      });
    }
  } catch (e) {
    log('error', e);
    isGeneratingTokenPromise = null;
    window.turnstile?.remove();
  }
};

export const getTurnstileToken = async () => {
  let token;
  try {
    if (isGeneratingTokenPromise) await isGeneratingTokenPromise;

    token = window.turnstile?.getResponse();

    if (isGeneratingTokenPromise) removeTurnstile();
    // eslint-disable-next-line no-empty
  } catch (e) {}

  return token;
};

// use remove instead of reset
// turnstile.reset will set iframe.src and web add an entry to history
// and then cause some chaos when navigating
const removeTurnstile = async () => {
  log('reset token by remove turnstile');
  window.turnstile?.remove();

  initTurnstile({ ...storedParams, isReset: true });
};
